// Core
import React from 'react';
// Styles
import './Card.css';
// Components
import Icon from '../Icon/Icon.js';

const Card = props => {
    return (
        <li className={props.for ? props.for : 'card'}>
            {/* <Icon icon="close" /> */}
            {/* <h2>{props.heading}</h2> */}
            {props.children}
        </li>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card/Card.js